import { defineStore } from "pinia";
import { ref } from "vue";
import type { PatientCollection } from "~/types/order-processing";

interface CreateOrderResponse {
  order_token: string | null;
  order_id: string | null;
}

const getDefaultPatientCollection = (): PatientCollection => ({
  allowMultipleRecipients: false,
  orderForMultipleUser: false,
  shippingCost: 0,
  recipients: [],
});

const defaultCreateOrderResponse: CreateOrderResponse = {
  order_token: null,
  order_id: null,
};

export const useOrderStore = defineStore("order", () => {
  //States
  const patientsCollection = ref<PatientCollection>(getDefaultPatientCollection());
  const createOrderResponse = ref<CreateOrderResponse>(defaultCreateOrderResponse);

  //Actions
  function updatePatientsCollection(data: PatientCollection) {
    patientsCollection.value = data;
  }

  function setCreateOrderResponse(value: CreateOrderResponse) {
    createOrderResponse.value = value;
  }

  function $reset() {
    patientsCollection.value = getDefaultPatientCollection();
    createOrderResponse.value = defaultCreateOrderResponse;
  }

  return {
    patientsCollection,
    createOrderResponse,
    updatePatientsCollection,
    setCreateOrderResponse,
    $reset,
  };
});
